import type { ThermalPrinter } from "@/data/GroupPrinter.ts";
import { groupPrinters0 } from "@/data/GroupPrinterHub.ts";
import type { Order } from "@/data/Order.ts";
import { generalSetting0 } from "@/data/PosSettingsSignal.ts";
import type { OrderItem } from "@/pos/OrderType.ts";
import { multipleMenus0 } from "@/react/EditMenuView/EditPricingLevel.logic.ts";
import { getReceiptsFromOrder, printKitchenReceipt } from "@/react/Printer/print-kitchen-utils.ts";
import { getMappedPrinter } from '@/react/Printer/print-utils.ts';
import { VPrinter } from "@/react/Printer/VPrinter.ts";
import debug from "debug";
import _ from "lodash";
import pako from "pako";

const log = debug('printer:print-kitchen');

let result: string;
const queues = {};
//todo: one instance -> reuse

const isPrintKitchenFollowMenu = (order: Order) => {
  if (!generalSetting0().multipleDineInMenusEnable) return true;
  if (!!order?.provider) return true;
  let isPrintKitchen;
  if (!order?.multiplePriceMenu) {
     isPrintKitchen = multipleMenus0()?.[0]?.isPrintKitchen;
  } else {
     isPrintKitchen = multipleMenus0()?.find(m => m._id === order?.multiplePriceMenu)?.isPrintKitchen;
  }
  return isPrintKitchen
}

const printedData: string[] = [];
//todo define Printer in ts
export const printKitchen = async (order: Order, printed = true, isReprint = false): Promise<void> => {
  log(`printKitchen `, { orderId: order._id })
  if (!isPrintKitchenFollowMenu(order)) return;
  if (printedData.indexOf(order._id) !== -1) return;
  printedData.push(order._id);
  setTimeout(() => printedData.splice(printedData.indexOf(order._id), 1), 3000)

  if (isReprint) {
    const items = order?.seatMode ? order?.seatMap?.flatMap(o => o.items)?.filter(i => i.quantity) : order.items?.filter(i => i.quantity);
    if (items && items?.length) {
      await printItems(items, false);
    }
  } else {
    const items = order.getRecent!(printed);
    if (items?.length) {
      const itemInfo = items.map(item => 
        `${item.name || ''} | Course: ${item.course || '-'} | Printer: ${item.groupPrinter || 'No printer'}`
      );
      log('Items to print:\n' + itemInfo.join('\n'));
    }
    await printItems(items, false);
    const cancellationItems = order.getCancellationRecent!(printed);
    await printItems(cancellationItems, true);
  }


  async function printItems(items: OrderItem[], cancel: boolean = false) {
    const groupReceipts = getReceiptsFromOrder(items);


//["{\"groupPrinter\":\"5e7864b186e3ec0997b5e48e\",\"course\":1}"]
    for (let [key, _items] of _.entries(groupReceipts)) {
      const {groupPrinter: _id, course} = JSON.parse(key);
      const groupPrinter = groupPrinters0().find(g => g._id === _id);
      if (!groupPrinter) return;
      const kitchenPrinter = getMappedPrinter(groupPrinter);
      if (!kitchenPrinter) return;
      if (kitchenPrinter.oneReceiptForOneArticle) {
        for (const item of _items) {
          if (item.course === course) {
            processPrint(groupPrinter.name, kitchenPrinter, course, [item]).then();
          }
        }
      } else {
        processPrint(groupPrinter.name, kitchenPrinter, course, _items).then();
      }
    }

    async function processPrint(groupPrinterName: string, kitchenPrinter: ThermalPrinter, course: number, _items: OrderItem[]) {
      const vPrinter = new VPrinter(kitchenPrinter, {lazy: true})
      await printKitchenReceipt(groupPrinterName, kitchenPrinter, course, _items, order, cancel, false, vPrinter, isReprint);
      vPrinter.print({viaMaster: true, createVirtualPrinter: true, virtualPrinterMetadata: {orderId: order._id}}).then();
    }
  }

  // return result;
}
